import { useEffect, useState } from "react";
import axios from "axios";
import { FileText, RefreshCw } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Admin() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = async () => {
    setLoading(true);
    try {
      const { data } = await axios.get(`${API}/enquiries`);
      setItems(data);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => { load(); }, []);

  return (
    <div className="pt-[74px] min-h-screen bg-[#F4F6F9]">
      <div className="max-w-[1500px] mx-auto px-5 md:px-10 py-16">
        <div className="flex items-center justify-between mb-10">
          <div>
            <div className="overline mb-2">Internal</div>
            <h1 className="font-display font-extrabold text-4xl tracking-tight text-[#0E1626]">Enquiries ({items.length})</h1>
          </div>
          <button onClick={load} className="btn-outline" data-testid="admin-refresh"><RefreshCw size={16} /> Refresh</button>
        </div>

        {loading ? <p className="text-slate-500 font-mono">Loading...</p> : items.length === 0 ? (
          <p className="text-slate-500 font-mono">No enquiries yet.</p>
        ) : (
          <div className="space-y-4" data-testid="admin-enquiry-list">
            {items.map((e) => (
              <div key={e.id} className="border border-[#DCE1E8] p-6 bg-white" data-testid={`admin-enquiry-${e.id}`}>
                <div className="flex flex-wrap justify-between gap-4">
                  <div>
                    <div className="font-display font-bold text-xl tracking-tight text-[#0E1626]">{e.name} {e.company && <span className="text-slate-400">· {e.company}</span>}</div>
                    <div className="font-mono text-xs text-slate-500 mt-1">{e.phone} · {e.email}</div>
                  </div>
                  <div className="font-mono text-xs text-slate-400">{new Date(e.created_at).toLocaleString()}</div>
                </div>
                <div className="grid sm:grid-cols-4 gap-4 mt-5 font-mono text-xs">
                  <div><span className="text-slate-400">Type:</span> <span className="text-slate-700">{e.requirement_type || "—"}</span></div>
                  <div><span className="text-slate-400">Material:</span> <span className="text-slate-700">{e.material || "—"}</span></div>
                  <div><span className="text-slate-400">Qty:</span> <span className="text-slate-700">{e.quantity || "—"}</span></div>
                  <div><span className="text-slate-400">Delivery:</span> <span className="text-slate-700">{e.delivery_date || "—"}</span></div>
                </div>
                {e.details && <p className="text-slate-600 font-light mt-4 leading-relaxed">{e.details}</p>}
                {e.files?.length > 0 && (
                  <div className="flex flex-wrap gap-3 mt-4">
                    {e.files.map((f) => (
                      <a key={f.id} href={`${API}/enquiries/${e.id}/files/${f.id}/download`} target="_blank" rel="noreferrer" className="inline-flex items-center gap-2 border border-[#DCE1E8] px-3 py-2 text-xs font-mono text-slate-700 hover:border-[#1D4ED8] transition-colors">
                        <FileText size={14} className="text-[#1D4ED8]" /> {f.original_filename}
                      </a>
                    ))}
                  </div>
                )}
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
